// extracted by mini-css-extract-plugin
module.exports = {"header":"TransactionTable_header__n8olN","label":"TransactionTable_label__1pZQz","switch":"TransactionTable_switch__1-ncu","number":"TransactionTable_number__1MKQr"};